"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicElement = void 0;
const class_validator_1 = require("class-validator");
const _1 = require(".");
const Transform_1 = require("./Transform");
class PublicElement {
    constructor(data) {
        this.order = _1.DEFAULT_ORDER;
        this.zIndex = 0;
        this.id = data.id;
        this.categories = data.categories;
        this.transform = data.transform;
        this.name = data.name;
        this.thumb = data.thumb;
        this.order = data.order;
        this.zIndex = data.zIndex;
        this.mappingCategoryPaletteColors = data.mappingCategoryPaletteColors;
    }
}
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], PublicElement.prototype, "id", void 0);
__decorate([
    class_validator_1.IsString({ each: true }),
    __metadata("design:type", Array)
], PublicElement.prototype, "categories", void 0);
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", typeof (_a = typeof Transform_1.TransformId !== "undefined" && Transform_1.TransformId) === "function" ? _a : Object)
], PublicElement.prototype, "transform", void 0);
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], PublicElement.prototype, "name", void 0);
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], PublicElement.prototype, "thumb", void 0);
__decorate([
    class_validator_1.IsNumber(),
    __metadata("design:type", Number)
], PublicElement.prototype, "order", void 0);
__decorate([
    class_validator_1.IsNumber(),
    __metadata("design:type", Number)
], PublicElement.prototype, "zIndex", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsObject(),
    __metadata("design:type", Object)
], PublicElement.prototype, "mappingCategoryPaletteColors", void 0);
exports.PublicElement = PublicElement;
// export class Element extends NetworkModel implements IElement {
// 	@IsString()
// 	id!: ElementId
// 	@IsString()
// 	name!: string
// 	@IsString({ each: true })
// 	categories: CategoryId[] = []
// 	// @IsString({ each: true })
// 	// palettes!: PaletteId[]
// 	// @IsObject()
// 	// mutableColors?: IMutableColors[]
// 	@IsString()
// 	transform?: TransformId
// 	@IsString()
// 	thumb!: string
// 	@IsObject({ each: true })
// 	masks?: IMask[]
// 	@IsString()
// 	svg!: string
// 	@IsNumber()
// 	order: number = DEFAULT_ORDER
// 	@IsBoolean()
// 	visible: boolean = true
// 	@IsNumber(
// 		{
// 			allowNaN: false,
// 			allowInfinity: false,
// 		},
// 		{ each: true }
// 	)
// 	svgBounding!: [number, number, number, number]
// 	@IsOptional()
// 	@IsObject()
// 	mappingCategoryPaletteColors?: MappingCategoryPaletteColors
// 	static isSettedBounding(bounding: [number, number, number, number]) {
// 		return bounding.some(e => e !== 0)
// 	}
// }
